module.exports = __webpack_public_path__ + "static/media/project_brand.6293ceb1.jpg";